import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DeliveryDiscountBranchesFilterEntity } from '../../domain/entities/DeliveryDiscountBranchesFilterEntity'

export class DeliveryDiscountBranchesFilterModel extends DeliveryDiscountBranchesFilterEntity {
  branchId?: number
  constructor(dataDto: DeliveryDiscountBranchesFilterEntity) {
    super()
    mapEntityProperties<DeliveryDiscountBranchesFilterModel>(this, dataDto, {
      exclude: ['branch'],
      map: {
        branchId: dataDto.branch?.id
      }
    })
  }
}
